var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreedots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 4,
    viewBox: "0 0 17 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0C3.2165 0 4 0.826162 4 1.84529C4 2.86441 3.2165 3.69057 2.25 3.69057C1.2835 3.69057 0.5 2.86441 0.5 1.84529C0.5 0.826162 1.2835 0 2.25 0Z",
    fill: "#868FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0C9.7165 0 10.5 0.826162 10.5 1.84529C10.5 2.86441 9.7165 3.69057 8.75 3.69057C7.7835 3.69057 7 2.86441 7 1.84529C7 0.826162 7.7835 0 8.75 0Z",
    fill: "#868FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 0C16.2165 0 17 0.826162 17 1.84529C17 2.86441 16.2165 3.69057 15.25 3.69057C14.2835 3.69057 13.5 2.86441 13.5 1.84529C13.5 0.826162 14.2835 0 15.25 0Z",
    fill: "#868FAD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/Threedots.bb7e03c30a4342ddb38a657441e8850a.svg";
export { ForwardRef as ReactComponent };